const getLabel = (options, value) => {
  const { label } = options.find(option => option.value === value);
  return label;
};

export default getLabel;
